import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';
import { OptionsPropType } from '../../shared/propTypes/common';

import schema from './communicationForm.schema';
import { clientsToChooseFromSelector } from './store/selectors';
import { userFullNameSelector } from '../../shared/store/selectors';
import { messagePropTypes } from './propTypes';

const ModalTitles = {
  ADD: 'Add Communication',
  EDIT: 'Edit Communication',
};

class AddEditCommunicationsModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    userName: PropTypes.string.isRequired,
    entityToEdit: PropTypes.shape(messagePropTypes),
    isSavingCommunication: PropTypes.bool,
    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool,
    clientsToChooseFrom: OptionsPropType,
  };

  save = (formData, { setSubmitting, resetForm }) => {
    const { saveEntity, userName, openForEdit, entityToEdit } = this.props;

    saveEntity({
      ...formData,
      name: formData.nameOverride || userName,
      communicationId: entityToEdit ? entityToEdit.communicationId : null,
    }, openForEdit, { callback: resetForm });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      userName,
      hideModal,
      isVisible,
      isSavingCommunication,
      clientsToChooseFrom,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-connection-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingCommunication}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            userName,
            openForEdit,
            clientsToChooseFrom,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientsToChooseFrom: clientsToChooseFromSelector(state),
    userName: userFullNameSelector(state),
  };
}

export default connect(mapStateToProps)(AddEditCommunicationsModal);
